import { createAppKit } from '@reown/appkit/react'

import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactNode } from 'react'
import {
  defaultNetwork,
  generalConfig,
  wagmiAdapter
} from '@/constants/walletConnectionConfig'

const queryClient = new QueryClient()

const supportedWallets = [
  'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96'
]

createAppKit({
  ...generalConfig,
  adapters: [wagmiAdapter],
  features: {
    email: false,
    socials: false
  },
  enableCoinbase: false,
  allWallets: 'ONLY_MOBILE',
  //this option brеаks the connection on mobile (@reown/appkit v 1.5.0)
  // enableWalletConnect: false,
  defaultNetwork,
  includeWalletIds: supportedWallets,
  featuredWalletIds: supportedWallets,
  themeMode: 'light',
  themeVariables: {
    '--w3m-accent': '#fff'
  },
  allowUnsupportedChain: true,
  networks: [defaultNetwork]
})

type Props = {
  children: ReactNode
}

const AppKitProvider = ({ children }: Props) => {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}

export default AppKitProvider
